/**
 * Müşteriler read model (GET /customers, v0.1.58): the contract's shape, re-exported so the
 * screens import from one place, plus the Turkish words the page uses. Read only.
 */

import { CUSTOMER_SOURCE_LABELS_TR } from '@twin/contracts';

export type {
  Customer,
  CustomerEvent,
  CustomerEventKind,
  CustomerSource,
  CustomerSourceStat,
  CustomersView,
} from '@twin/contracts';

export function customerSourceLabel(source: string): string {
  return (CUSTOMER_SOURCE_LABELS_TR as Record<string, string>)[source] ?? source;
}

/** What a customer row says about orders: nothing, one order, or n orders. */
export function ordersText(orders: number): string | null {
  if (orders === 0) return null;
  return orders === 1 ? '1 sipariş' : `${orders} sipariş`;
}
